module.exports = __webpack_public_path__ + "img/Top-Users-by-Number-of-Reviewes-300x243.586c7c54.png";